var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    staticClass: "s-flex s-items-center s-py-5"
  }, [_c('div', {
    staticClass: "s-mr-auto s-space-y-2"
  }, [_c('p', {
    staticClass: "s-font-semibold s-text-gray-darker s-text-lg"
  }, [_vm._v(_vm._s(_vm.point.branch.name))]), _c('p', {
    staticClass: "s-text-gray-dark s-text-xs"
  }, [_vm._v(_vm._s(_vm.point.memo))]), _c('p', {
    staticClass: "s-text-gray s-text-xs"
  }, [_vm._v("交易日期 " + _vm._s(_vm.orderDate))]), _c('p', {
    staticClass: "s-text-gray s-text-xs"
  }, [_vm._v("紅利點數效期 " + _vm._s(_vm.expiredDate))])]), _c('div', {
    staticClass: "s-font-semibold s-text-xl s-flex-shrink-0",
    class: _vm.pointClass
  }, [_vm._v(" " + _vm._s(_vm.displayPoint) + " ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }